import { site } from '../config';
import Icon from './Icon';

export default function CallButton({ children, variant = 'outline', size, block, className = '' }) {
  const classes = ['btn', `btn-${variant}`, size && `btn-${size}`, block && 'btn-block', className]
    .filter(Boolean)
    .join(' ');

  return (
    <a href={site.phoneHref} className={classes}>
      <Icon name="phone" size={18} />
      {children || site.phone}
    </a>
  );
}
